import { get, post, put, deleted } from '..';
import routes from './routes';

const PaymentHeadServices = {
  createPaymentHead: async (obj) => {
    const data = await post(routes.createPaymentHead, obj);
    return data;
  },
  getPaymentHeads: async (params) => {
    const data = await get(routes.getPaymentHeads, params);
    return data;
  },
  getPaymentHeadById: async (id) => {
    const data = await get(routes.getPaymentHeadById + id);
    return data;
  },
  updatePaymentHead: async (id, obj) => {
    const data = await put(routes.updatePaymentHead + id, obj);
    return data;
  },
  deletePaymentHead: async (id) => {
    const data = await deleted(routes.deletePaymentHead + id);
    return data;
  },
}

export default PaymentHeadServices